/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const rejectDataRemovalRequestDataSchema = z.object({
	rejectionReason: z.string(),
})

export type RejectDataRemovalRequestDataSchema = z.infer<typeof rejectDataRemovalRequestDataSchema>
